import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../../store/validation/is-Empty";
import {
  superadmin_create_and_update_restaurant,
  superadmin_create_restaurant_chains,
} from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { get_all_restaurant_chain } from "../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import axios from "axios";
import { serverApi } from "../../../../../config/Keys";
import Alert from "react-s-alert";
// import { RestaurantChainSettings } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantChainSettings";

// COMPONENTS
import RestaurantChainWrapperComponent from "./RestaurantChainWrapperComponent";
import RestaurantChainToggle from "./RestaurantChainSelectToggle";
import RestaurantChainListComponent from "./RestaurantChainsListComponent";
import RestaurantChainAddComponent from "./RestaurantChainAddComponent";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class SuperAdminRestaurantChain extends Component {
  constructor() {
    super();
    this.state = {
      vendor_id: "",
      actionButton: false,
      loader: false,
      restaurant_chain_id: "",
      all_restaurant_chains: [],
      location_code: "",
      are_you_part_of_chain: false,
      is_suggest_new_open: false,
      title: "",
      icon: [],
      address: "",
      area: "",
      city: "",
      phone_numbers: [{ country_code: "", mobile_no: "" }],
      enquiry_emails: [""],
      emailError: "",
      phoneError: "",
      status: "NOTAPPROVED",
      search: "",
      errors: {},
      country_code: "",
      editActionByAdmin: false,
    };
  }

  // CONSTANTS:
  // FOR STATUS USE --> NOTAPPROVED, APPROVED
  componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (this.props?.auth?.loader) {
      this.setState({
        loader: true,
      });
    }
    this.props.get_all_restaurant_chain(this.props.auth.user.accessToken);
    let phone_numbers = [{ country_code: "", mobile_no: "" }];
    axios
      .get("https://ipapi.co/json")
      .then((result) => {
        phone_numbers[0].country_code = result.data.country_calling_code;
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
          phone_numbers: phone_numbers,
        });
      })
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps.chainlist);
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      !isEmpty(onboarding?._id) &&
      !isEmpty(nextProps.chainlist) &&
      !nextState.hasSetMapProps
    ) {
      return {
        restaurant_chain_id: !isEmpty(onboarding?.restaurant_chain_id)
          ? !isEmpty(onboarding?.restaurant_chain_id?._id)
            ? onboarding?.restaurant_chain_id?._id
            : onboarding?.restaurant_chain_id
          : "",
        location_code: !isEmpty(onboarding?.location_code)
          ? onboarding?.location_code
          : "",
        are_you_part_of_chain: onboarding?.restaurant_chain_id ? true : false,
        all_restaurant_chains: nextProps?.chainlist.filter(
          (chain) => chain.status !== "NOTAPPROVED"
        ),
        editActionByAdmin: !isEmpty(nextProps?.editDataAction)
          ? nextProps?.editDataAction
          : false,
        hasSetMapProps: true,
      };
    }
    if (nextProps?.auth?.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps?.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onToggleHandler = (name, value) => (e) => {
    this.setState({
      [name]: value,
      actionButton: true,
    });
  };

  onChangeHandler = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    this.setState({
      [e.target.name]: newData,
      actionButton: true,
    });
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  onEmailChangeHandler = (index) => (e) => {
    let enquiry_emails = this.state.enquiry_emails;
    enquiry_emails[index] = e.target.value;
    this.setState({
      enquiry_emails: enquiry_emails,
      emailError: "",
      actionButton: true,
    });
  };

  onPhoneDataChangeHandler = (name, index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    if (name === "mobile_no") {
      phone_numbers[index][name] = e.target.value.slice(0, 10);
    } else {
      phone_numbers[index][name] = e.target.value;
    }

    this.setState({
      phone_numbers: phone_numbers,
      phoneError: "",
      actionButton: true,
    });
  };

  onEmailPhoneAddDeleteHandler = (name, operation, index) => (e) => {
    e.preventDefault();
    let errorPopup = false;
    let errorPopupPhone = false;
    if (name === "phone") {
      if (operation === "add") {
        let phone_numbers = this.state.phone_numbers;
        if (
          phone_numbers[phone_numbers.length - 1].mobile_no === "" ||
          phone_numbers[phone_numbers.length - 1].mobile_no.length < 10
        ) {
          errorPopupPhone = true;
          this.setState({ errors: {} });
        } else {
          phone_numbers.push({
            country_code: this.state.country_code,
            mobile_no: "",
          });
          this.setState({ phone_numbers: phone_numbers, errors: {} });
        }
      } else {
        let phone_numbers = this.state.phone_numbers;
        if (phone_numbers.length === 1) {
          errorPopupPhone = true;
          this.setState({ errors: {} });
        } else {
          phone_numbers.splice(index, 1);
          this.setState({ phone_numbers: phone_numbers, errors: {} });
        }
      }
    } else if (name === "email") {
      if (operation === "add") {
        let enquiry_emails = this.state.enquiry_emails;
        if (!validEmailRegex.test(enquiry_emails[enquiry_emails.length - 1])) {
          errorPopup = true;
          this.setState({ errors: {} });
        } else {
          enquiry_emails.push("");
          this.setState({ enquiry_emails: enquiry_emails, errors: {} });
        }
      } else {
        let enquiry_emails = this.state.enquiry_emails;
        if (enquiry_emails.length === 1) {
          errorPopup = true;
          this.setState({ errors: {} });
        } else {
          enquiry_emails.splice(index, 1);
          this.setState({ enquiry_emails: enquiry_emails, errors: {} });
        }
      }
    } else {
    }
    if (errorPopup === true) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.email = `email is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    } else if (errorPopupPhone === true) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.mobile_no = `phone number is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    }
  };

  onSingleImageDrop = (picture) => {
    this.setState({
      icon: picture,
      actionButton: true,
    });
  };

  onBackButtonSuggestNew = (e) => {
    this.setState({
      is_suggest_new_open: false,
    });
  };

  onBackButtonChainPage = (e) => {
    this.setState({
      are_you_part_of_chain: false,
    });
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/
  onImageLogoUploadHandler = (e) => {
    // this.setState({ loader: true });
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    const vendor_id = this.state?.vendor_id;
    const restaurant_name = onboarding?.restaurant_name.split(" ").join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    data.append("files", e.target.files[0]);
    axios
      .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        this.setState({ icon: res.data, loader: false });
        Alert.success(`<h4>Restaurant Chain Image Upload Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      })
      .catch((err) => {
        this.setState({ loader: false });
        Alert.error(`<h4>Error while uploading the image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      });
  };

  removeFile = (e) => {
    let removeIconImage = this.state.icon;
    removeIconImage = "";
    this.setState({
      icon: removeIconImage,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_restaurant_type"
        : "/addvendorrestauranttype"
    );
  };

  onhandleSubmit = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      vendor_id: this.state.vendor_id,
      restaurant_chain_id: this.state.restaurant_chain_id,
      location_code: this.state.location_code,
      id: onboarding?._id,
      page_completed_till: 5,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_restaurant_type"
        : "/addvendorrestauranttype"
    );
  };

  onSuggestNewSubmitHandler = (e) => {
    let formData = {
      title: this.state.title,
      icon: this.state.icon.toString(),
      address: this.state.address,
      area: this.state.area,
      city: this.state.city,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      status: "NOTAPPROVED",
      page_completed_till: 5,
    };
    this.props.superadmin_create_restaurant_chains(
      formData,
      this.props.history
    );
  };

  localProps = {
    onWithOutApiCall: this.onWithOutApiCall,
    onBackButtonChainPage: this.onBackButtonChainPage,
    onBackButtonSuggestNew: this.onBackButtonSuggestNew,
    onhandleSubmit: this.onhandleSubmit,
    onSuggestNewSubmitHandler: this.onSuggestNewSubmitHandler,
    onToggleHandler: this.onToggleHandler,
    onChangeHandler: this.onChangeHandler,
    onFocusOut: this.onFocusOut,
    onImageLogoUploadHandler: this.onImageLogoUploadHandler,
    removeFile: this.removeFile,
    onEmailChangeHandler: this.onEmailChangeHandler,
    onSingleImageDrop: this.onSingleImageDrop,
    onEmailPhoneAddDeleteHandler: this.onEmailPhoneAddDeleteHandler,
    onPhoneDataChangeHandler: this.onPhoneDataChangeHandler,
  };
  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <RestaurantChainWrapperComponent
        localProps={this.localProps}
        state={this.state}
        {...this.props}
      >
        {this.state.is_suggest_new_open === false ? (
          <RestaurantChainToggle
            state={this.state}
            localProps={this.localProps}
          />
        ) : null}
        {this.state.are_you_part_of_chain === true &&
        this.state.is_suggest_new_open === false ? (
          <RestaurantChainListComponent
            state={this.state}
            localProps={this.localProps}
          />
        ) : null}
        {this.state.are_you_part_of_chain === true &&
        this.state.is_suggest_new_open === true ? (
          <RestaurantChainAddComponent
            state={this.state}
            localProps={this.localProps}
          />
        ) : null}
      </RestaurantChainWrapperComponent>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  chainlist: state.category.restaurant_chain,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
  superadmin_create_restaurant_chains,
  get_all_restaurant_chain,
})(withRouter(SuperAdminRestaurantChain));
